export default class Chain<T> {
  public static NEXT = 'next'

  private next: Chain<T> | null
  private fn: Function

  public constructor(fn: Function) {
    this.fn = fn
    this.next = null
  }

  public setNext(next: Chain<T>): void {
    this.next = next
  }

  public async run(...args: any[]): Promise<T> {
    const ret = await this.fn.apply(this, args)
    if (ret === Chain.NEXT && this.next) {
      const result: T = await this.next.run.apply(this.next, args)
      return result
    }
    return ret
  }
}
